import { render, staticRenderFns } from "./login-register.vue?vue&type=template&id=6dc85ff9&scoped=true&"
import script from "./login-register.vue?vue&type=script&lang=js&"
export * from "./login-register.vue?vue&type=script&lang=js&"
import style0 from "./login-register.vue?vue&type=style&index=0&id=6dc85ff9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc85ff9",
  null
  
)

export default component.exports